// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"d5212c36","31":"b65ee736","89":"d5212c36","283":"d51fe0b8"}[chunkId] + ".css";
};